var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasaMuscularImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.215,
    height: 20.214,
    viewBox: "0 0 20.215 20.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12906",
    "data-name": "Group 12906",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7328",
    "data-name": "Path 7328",
    d: "M4716.437,96.685c.089-.395.146-.8.273-1.182a4.985,4.985,0,0,1,5.036-3.385,5.117,5.117,0,0,1,3.92,2.163c.033.044.067.088.1.137a4.008,4.008,0,0,1,4.542-.3c0-.067.009-.126.009-.185V88.957c0-.467-.208-.677-.673-.677-.812,0-1.625,0-2.438,0a1.688,1.688,0,0,1-1.767-1.771q0-1.051,0-2.1a1.689,1.689,0,0,1,1.763-1.756c1.151,0,2.3-.005,3.452,0a2.77,2.77,0,0,1,2.511,1.433c.7,1.17,1.377,2.35,2.067,3.524a2.968,2.968,0,0,1,.413,1.536q0,5.084,0,10.168a.671.671,0,0,1-.43.673,19.177,19.177,0,0,1-5.776,1.715c-.482.064-.97.088-1.455.131-.074.007-.148.02-.222.03h-6.979c-.049-.011-.1-.026-.145-.034a4.665,4.665,0,0,1-3.942-3.18,8.763,8.763,0,0,1-.266-1.14Zm8.465-1.506c-.018-.034-.027-.056-.04-.076-.037-.058-.073-.117-.115-.171a3.97,3.97,0,0,0-4.071-1.616,3.861,3.861,0,0,0-3.048,4.47,3.615,3.615,0,0,0,3.565,2.952c1.857.005,3.714.015,5.571-.005.817-.009,1.637-.055,2.45-.145a17.185,17.185,0,0,0,5.188-1.459.181.181,0,0,0,.123-.2c0-3.289,0-6.578-.01-9.867a1.6,1.6,0,0,0-.188-.752q-1.077-1.9-2.2-3.769a1.519,1.519,0,0,0-1.329-.757c-1.219-.019-2.438-.009-3.658-.005a.55.55,0,0,0-.566.555q-.009,1.125,0,2.251a.553.553,0,0,0,.572.568c.3.006.6,0,.9,0h.762V86.4c-.169,0-.325,0-.481,0a.566.566,0,1,1-.007-1.125c.319,0,.638,0,.957,0,.462,0,.669.211.67.679v1.188a.566.566,0,0,0,.071.03,1.682,1.682,0,0,1,1.43,1.787q0,1.538,0,3.076v3.226a.553.553,0,0,1-.331.542.543.543,0,0,1-.611-.1c-.115-.1-.229-.194-.341-.292a2.8,2.8,0,0,0-3.807,0c-.473.408-.95.813-1.423,1.222a.6.6,0,0,1-.493.18.563.563,0,0,1-.289-.992C4724.4,95.607,4724.65,95.395,4724.9,95.179Z",
    transform: "translate(-4716.437 -82.649)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7329",
    "data-name": "Path 7329",
    d: "M4806.383,198.024c0,.238.006.475,0,.713a.562.562,0,1,1-1.122,0q-.01-.722,0-1.444a.562.562,0,1,1,1.122,0C4806.389,197.537,4806.383,197.781,4806.383,198.024Z",
    transform: "translate(-4800.812 -190.995)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7330",
    "data-name": "Path 7330",
    d: "M4747.166,202.514a.569.569,0,0,1-.393.582.53.53,0,0,1-.624-.216c-.274-.453-.541-.911-.794-1.376a.557.557,0,0,1,.966-.552c.272.447.529.9.786,1.359A.756.756,0,0,1,4747.166,202.514Z",
    transform: "translate(-4743.85 -194.793)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7331",
    "data-name": "Path 7331",
    d: "M4851.594,199.852a.552.552,0,0,1,.512.788c-.249.481-.525.948-.811,1.408a.539.539,0,0,1-.733.148.549.549,0,0,1-.217-.717c.255-.471.518-.939.809-1.388.083-.129.27-.191.41-.284Z",
    transform: "translate(-4843.59 -193.945)",
    fill: "#394f65",
    stroke: "#394f65",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasaMuscularImage);
export default __webpack_public_path__ + "static/media/masa_muscular_image.b9b89cc8a706edbf2f879a2206f0a9f8.svg";
export { ForwardRef as ReactComponent };